import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';
import { DataManipService } from './data-manip.service';
import { CommonService } from './common.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private dataManipSrvc: DataManipService, private commonServices: CommonService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        let currentUser = this.dataManipSrvc;

        // console.log("token currentUser",JSON.stringify(currentUser));

        if (currentUser && currentUser.apiToken && currentUser.userId) {
            request = request.clone({
                setHeaders: {
                    "authorization": `Bearer ${currentUser.apiToken}`,
                    "authfor": "W"
                }
            });
            // console.log(request)
        } else {
            this.commonServices.logout();
            this.dataManipSrvc.apiToken = "";
        }

        return next.handle(request);
    }
}